import { useCurrentUser } from '@/hooks/useCurrentUser';

import { canAccessComponent, getUserPermissions, hasPermission } from '@/lib/permissions';

/**
 * Hook to check user permissions
 */
export function usePermissions() {
  const { userData } = useCurrentUser();

  return {
    user: userData,
    hasPermission: (permissionName: string) => hasPermission(userData, permissionName),
    canAccessComponent: (options: { requiredPermissions: string[] }) =>
      canAccessComponent(userData, options),
    permissions: getUserPermissions(userData),
  };
}
